module.exports = __webpack_public_path__ + "img/Timezone_550_Screenshot_iphone13.e585173f.png";